var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtsyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 40H0V0h40v40zm-8.93-2.88h6.05V2.88H2.88v34.24h25.31v-7.88h2.88v7.88zM12.95 7.01h3.17L22 22.14h-3.04L17.4 17.9h-5.7l-1.59 4.24H7.07l5.88-15.13zm1.59 3.06l-1.95 5.27h3.88l-1.93-5.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtsyLogo);
export default __webpack_public_path__ + "static/media/artsy-logo.eed9021c43937a308dbe98131f4469e3.svg";
export { ForwardRef as ReactComponent };